import React, { useState } from 'react';
import styled, { withTheme } from 'styled-components'
import moment from 'moment'

import { Table, Button, Loading, Icon } from '../common';
import { Box, numberToCurrency } from 'vqp-common'
import { ClientDetailModal } from './'
import { ClientLoyaltyModal } from './loyalty/LoyaltyModal';
import formatCpf from '../../utils/formatCpf'
import formatPhone from '../../utils/formatPhone'


const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 15px;
`

const Card = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
`

const Title = styled.div`
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 16px;
    color: ${props => props.theme.colors.textBold}
`

const DetailButton = styled(Button)`
    font-size: 12px !important;
    svg {
        font-size: 16px;
        margin-right: 4px;
    }
`

const defaultText = "Digite no campo de busca o nome, email ou CPF para listar os clientes."

export const ClientsTable = withTheme(({ clients, hasFilter, theme, loading }) => {

    const [detailClient, setDetailClient] = useState({})
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [loyaltyModalOpen, setLoyaltyModalOpen] = useState(false);

    const handleOpenDetailModal = (clientId) => {
        setDetailClient(clients.find(client => client.id === clientId))
        setDetailModalOpen(true)
    }

    const handleCloseDetailModal = () => {
        setDetailModalOpen(false)
    }

    const handleOpenLoyaltyModal = (clientId) => {
        setDetailClient(clients.find(client => client.id === clientId))
        setLoyaltyModalOpen(true);
    }

    const handleCloseLoyaltyModal = () => {
        setLoyaltyModalOpen(false);
    }

    const columns = [
        {
            Header: 'Nome',
            accessor: 'name',
        },
        {
            Header: 'CPF',
            accessor: 'cpf',
            Cell: props => formatCpf(props.value)
        },
        {
            Header: 'E-mail',
            accessor: 'email'
        },
        {
            Header: 'Telefone',
            accessor: 'phone',
            Cell: props => formatPhone(props.value)
        },
        {
            Header: 'N° Pedidos',
            accessor: 'totalOrders',
        },
        {
            Header: 'Total Pedidos',
            accessor: 'ordersValue',
            Cell: props => (numberToCurrency(props.value))
        },
        {
            Header: 'Último pedido',
            accessor: 'lastOrder',
            Cell: (props) => {
                const v = props.value;
                if (!v || !moment(v).isValid() || moment(v).year() < 1900) return '—';
                return moment(v).format('DD/MM/YYYY');
            }
        },
        {
            Header: '',
            accessor: 'id',
            Cell: props => (
                <DetailButton
                    className="success"
                    width={"120px"}
                    onClick={() => handleOpenDetailModal(props.value)}
                >
                    Ver detalhes
                </DetailButton>
            )
        },
        {
            Header: '',
            accessor: 'id',
            Cell: props => (
                <DetailButton
                    className="primary"
                    width={"120px"}
                    onClick={() => handleOpenLoyaltyModal(props.value)}
                >
                     <Icon width={"16px"} height={"16px"} name={"medal"} stroke={"primary"} fill={"white"} />
                    Fidelidade
                </DetailButton>
            )
        },
    ]

    if (!clients || loading) {
        return (
            <Loading />
        )
    }

    return (
        <Wrapper>
            <Title>Clientes</Title>
            <Card>
                <Table
                    className="-striped"
                    data={clients}
                    columns={columns}
                    noDataText={!hasFilter ? defaultText : "Nenhum resultado"}
                    getTrProps={() => ({
                        style: {
                            borderTop: `1px solid ${theme.colors.lightGrey}`,
                            alignItems: 'center',
                        }
                    })}
                    getTheadProps={() => ({
                        style: {
                            color: theme.colors.textBold,
                            fontWeight: '700'
                        }
                    })}
                />
            </Card>
            <ClientDetailModal client={detailClient} isOpen={detailModalOpen} onClose={handleCloseDetailModal} />
            {(loyaltyModalOpen && detailClient) &&
                <ClientLoyaltyModal client={detailClient} isOpen={loyaltyModalOpen} onClose={handleCloseLoyaltyModal} />
            }
        </Wrapper>
    )
})

